import { TmapLog } from '@tmap-web-lib/tmap-log-client'
import { getSearchParams } from '@tmap-web-lib/utils'

import { PageIdSearchParams } from '@/Providers'
import { logWithTag } from '@/features/utils/console'

const LOG = logWithTag('log.fn')
type SkipOption = 'logbox' | 'mixpanel'

export const sendEventLog = (
  actionId?: string,
  custom?: any,
  pageid?: string,
  skipOptions?: SkipOption | SkipOption[]
) => {
  const searchParams = getSearchParams<PageIdSearchParams>()
  const { extra } = searchParams
  const extraCustomFields = extra ? JSON.parse(decodeURIComponent(extra)).logbox : {}

  let log = TmapLog('event').setPageId(pageid ? pageid : '/my')
  const mergedCustoms = {
    ...custom,
    ...extraCustomFields,
  }
  if (actionId) log.setActionId(actionId)
  if (mergedCustoms) {
    Object.keys(mergedCustoms).forEach((key) => {
      log.setCustom(key, mergedCustoms[key])
    })
  }
  const skipArr = skipOptions ? (Array.isArray(skipOptions) ? skipOptions : [skipOptions]) : []
  const skip =
    skipArr.length > 0
      ? {
        skip: {
          ...(skipArr.includes('logbox') ? { logbox: true } : {}),
          ...(skipArr.includes('mixpanel') ? { mixpanel: true } : {}),
        },
      }
      : undefined

  log.send(skip).then(() => {
    LOG('sendEvent', {
      pageId: pageid,
      actionId,
      extraCustomFields,
    })
  })
}
